import { render, staticRenderFns } from "./SkeletonCostEffectivenessStudies.vue?vue&type=template&id=2e39c730&"
import script from "./SkeletonCostEffectivenessStudies.vue?vue&type=script&lang=js&"
export * from "./SkeletonCostEffectivenessStudies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports